import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["bordered", "endSlot", "middleSlot", "startSlot"];
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import AbstractToolbar from './AbstractToolbar';
import { BORDER_COLOR } from './TabConstants';
import { BASE_SPACING_X, LAYOUT_EDITOR_PADDING } from 'HubStyleTokens/sizes';
import { toPx } from '../utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
const COMPUTED_PADDING_LEFT = toPx(parseInt(LAYOUT_EDITOR_PADDING, 10) - parseInt(BASE_SPACING_X, 10));
const endsStyle = css(["flex-basis:auto;flex-grow:0;flex-shrink:0;.private-button{flex:1 0 auto;}"]);
const TabBar = styled(AbstractToolbar).withConfig({
  displayName: "UITabBar__TabBar",
  componentId: "mxzx8v-0"
})(["border-bottom:", ";padding-right:", ";padding-top:", ";"], ({
  bordered
}) => bordered && `1px solid ${BORDER_COLOR}`, LAYOUT_EDITOR_PADDING, LAYOUT_EDITOR_PADDING);
const TabInner = styled(AbstractToolbar.defaultProps.Inner).withConfig({
  displayName: "UITabBar__TabInner",
  componentId: "mxzx8v-1"
})(["margin:-", " 0 0 0;padding-left:", ";"], LAYOUT_EDITOR_PADDING, COMPUTED_PADDING_LEFT);
const TabStart = styled(AbstractToolbar.defaultProps.Start).withConfig({
  displayName: "UITabBar__TabStart",
  componentId: "mxzx8v-2"
})(["", ";"], endsStyle);
const TabMiddle = styled(AbstractToolbar.defaultProps.Middle).withConfig({
  displayName: "UITabBar__TabMiddle",
  componentId: "mxzx8v-3"
})(["flex-basis:auto;flex-grow:1;max-width:100%;min-width:50px;white-space:nowrap;"]);
const TabEnd = styled(AbstractToolbar.defaultProps.End).withConfig({
  displayName: "UITabBar__TabEnd",
  componentId: "mxzx8v-4"
})(["", ";"], endsStyle);
const UITabBar = props => {
  const {
      bordered,
      endSlot,
      middleSlot,
      startSlot
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(TabBar, Object.assign({}, rest, {
    bordered: bordered,
    End: TabEnd,
    endSlot: endSlot,
    Inner: TabInner,
    Middle: TabMiddle,
    middleSlot: middleSlot,
    responsive: false,
    Start: TabStart,
    startSlot: startSlot
  }));
};
UITabBar.propTypes = {
  /**
   * Determines if the tab bar has a bottom border.
   */
  bordered: PropTypes.bool.isRequired,
  /**
   * Specifies the slot where content should be placed at the end of a container or component. It can be used to append additional content to an existing set of elements.
   */
  endSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * Specifies the slot where content should be placed in the middle of a container or component.
   */
  middleSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * Specifies the slot where content should be placed at the beginning of a container or component. It can be used to prepend content to an existing set of elements, such as adding a set of action buttons.
   */
  startSlot: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
UITabBar.defaultProps = {
  bordered: false
};
UITabBar.displayName = 'UITabBar';
export default UITabBar;